import {AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, viewChild} from '@angular/core';
import {FormsModule} from '@angular/forms';
// import {DataGrid} from '@fluentui/web-components';

@Component({
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        FormsModule,
    ],
    template: `
        <div class="fullsize-vbox" style="align-items: flex-start; gap: 10px">
            <fluent-data-grid #grid style="max-height: 30em; overflow-y: auto;">
            </fluent-data-grid>
        </div>
    `,
    styles: `
    `
})
export class TestFluentDatagrid implements AfterViewInit {

    private readonly grid = viewChild.required<any>('grid');

    constructor() {
    }

    ngAfterViewInit(): void {
        this.grid().rowsData = this.newDataSet(10);
    }

    newDataSet(rowCount: number): object[] {
        const newRows: object[] = [];
        for (let i = 0; i <= rowCount; i++) {
            newRows.push(this.newDataRow(`${i + 1}`));
        }
        return newRows;
    }

    newDataRow(id: string): object {
        return {
            rowId: `rowid-${id}`,
            item1: `value 1-${id}`,
            item2: `value 2-${id}`,
            item3: `value 3-${id}`,
            item4: `value 4-${id}`,
        };
    }
}
